import React from 'react';
import { HelpCircleIcon, ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { preparationQuestions, systemCycle } from '../../data/salesContent';
export function ProblemSection() {
  return <section className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-147" data-mp="8kjsx8g4ag83">
      <div className="mx-auto max-w-6xl" data-id="element-148" data-mp="dj4ubb73v5y4">
        <SectionHeading title="El problema no es que te falte conocimiento" subtitle="El problema es todo lo que tenés que preparar antes de poder enseñar." data-id="element-149" data-mp="di265b163hlw" />
        <div className="mt-12 text-center" data-id="element-150" data-mp="3na8663oasql">
          <p className="text-2xl font-bold text-cream md:text-3xl" data-id="element-151" data-mp="3lrbv72e7hhzs">Sabés primeros auxilios.</p>
          <p className="mt-3 text-lg text-neutral-400 md:text-xl" data-id="element-152" data-mp="3qqf08mu6ro7r">
            Pero cuando llega el momento de dar una capacitación aparece el verdadero trabajo:
          </p>
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-153" data-mp="1jy5trqvca69g">
          {preparationQuestions.map(q => <li key={q} className="flex items-start gap-4 rounded-2xl border border-ink-line bg-ink p-6" data-id="element-154" data-mp="1nnkz8bolsjb8">
              <HelpCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-gold" aria-hidden="true" data-id="element-155" data-mp="1ip9q6364ucu2" />
              <span className="text-lg font-medium leading-snug text-cream md:text-xl" data-id="element-156" data-mp="1wgo8s8w4oc0l">{q}</span>
            </li>)}
        </ul>

        <div className="mx-auto mt-14 max-w-3xl space-y-6 text-center" data-id="element-157" data-mp="1sf306zqmmjw7">
          <p className="text-lg leading-relaxed text-neutral-400 md:text-xl" data-id="element-158" data-mp="14o71rjro0qfz">
            Y terminás con manuales abiertos, videos, apuntes, documentos y{' '}
            <strong className="text-cream" data-id="element-159" data-mp="zs8igal71ymf">horas de preparación solamente para construir una capacitación.</strong>
          </p>
          <p className="font-display text-xl font-extrabold uppercase text-gold md:text-2xl" data-id="element-160" data-mp="18q2avafu884b">
            Eso es exactamente lo que este sistema busca resolver.
          </p>
          <p className="text-lg text-neutral-400 md:text-xl" data-id="element-161" data-mp="2k5qzs7cnjh7r">No queremos darte otro ebook para leer una vez y guardar.</p>
          <p className="text-xl font-semibold text-cream md:text-2xl" data-id="element-162" data-mp="1hsuh2a3w5d02">
            Queremos darte un sistema al que puedas volver cada vez que necesites:
          </p>
        </div>

        <ol className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-3" data-id="element-163" data-mp="1qszlqchp9xaj">
          {systemCycle.map((step, i) => <li key={step} className="flex items-center gap-3" data-id="element-164" data-mp="1vqssb6mx0tbc" data-mpi={i}>
              <span className="rounded-full border border-gold/50 px-5 py-2 font-display text-base font-extrabold uppercase tracking-wide text-cream md:text-lg" data-id="element-165" data-mp="z23b7ij444qf">
                {step}
              </span>
              {i < systemCycle.length - 1 && <ArrowRightIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-166" data-mp="181q2hbi4nu5r" />}
            </li>)}
        </ol>
      </div>
    </section>;
}